module.exports = {"60x30": __webpack_public_path__ + "images/warning-30x60.png"};